
console.log('%c Welcome on map 2.6.0 - build on 15.April 2025', 'background: #101010; color:#ff5900; padding:5px');

(function($) {
    $(function ($) {

        if ('ontouchend' in document === false ) {
            // mobile issue: jquery-ui-tooltip shows up on click but never disappears ?
            $(document).tooltip({
                show: { effect: "fade", duration: 500, delay: 100 },
                hide: { effect: "fade", duration: 200 },
                content: function () {
                    return this.getAttribute("title");
                }
            });
        }

        $('img').on("error", function() {
            $(this).attr('src', '/img/frontend/no-image.png');
        });

        const anchoredLinks   = $(".content-nav a");
        anchoredLinks.on('click', function(e) {
            e.preventDefault();
            var dis     = $(this);
            var target  = $(dis.attr('href'));
            var offset  = target.offset()
            var topPos  = offset.top - 75;
            $("html, body").animate( { scrollTop: topPos}, 750,  function() {    // "easeInOutSine",
                window.location.hash = dis.attr('href');
                $("html, body").animate( { scrollTop: topPos}, 0); // "easeInOutSine",
            });
            anchoredLinks.not(dis).removeClass('active');
            dis.addClass('active');
        });
        scrollAnimateAnchoredLinks(anchoredLinks);

    });
})(jQuery);

navigateToUrl = function(url, event) {
    event.stopPropagation();
    location.href = url;
}

scrollAnimateAnchoredLinks = function(anchoredLinks) {
    var hashPart        = (window.location.hash);
    var anchoredItem    = $(hashPart);
    var anchorTagObj    = $(`a[href='${hashPart}']`);

    if (hashPart) {
        var offset  = anchoredItem.offset()
        var topPos  = offset.top - 75;
        $("html, body").animate( { scrollTop: topPos}, 750);   // "easeInOutSine",
        anchoredLinks.not(anchorTagObj).removeClass('active');
        anchorTagObj.addClass('active');
    }
}
